import styled from "styled-components";

export const FormContainer = styled.form`
  display: grid;
  grid-template-columns: repeat(2, calc(50% - 7.5px));
  gap: 15px;
  padding: 0 15px;
  margin-bottom: 32px;
`;

export const FormItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: relative;
`;

export const FormLabel = styled.label`
  font-size: 14px;
  line-height: 1.2;
`;

export const FormInput = styled.input`
  font-size: 16px;
  line-height: 1.2;
  padding: 8px 12px;
  background-color: #fff;
  border-radius: 12px;
  border: none;
  outline: none;
  transition: box-shadow 0.3s ease 0s;
  margin-top: auto
  max-width: 100%;

  &:focus {
    box-shadow: 0 0 5px #2D53C84D;
  }
`;

export const FormRemove = styled.i`
  position: absolute;
  bottom: 3.5px;
  right: 12px;
  cursor: pointer;
`;